import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import CollectionsReviews from "../../Collection/components/CollectionsReview";
import KlydosReviews from "../../Klydos/KlydoReviewV2/components/KlydosReviewsContainer";
import PageHeader from "components/PageHeader";
import DSSegmentedTabs from "views/system-design/DSSegmentedTabs";
import {
  useHasNewKlydosInReview,
  useHasNewCollectionsInReview,
  markKlydosReviewVisited,
  markCollectionsReviewVisited,
} from "../../../components/hooks/useNewReviewItems";

export enum ReviewTab {
  Collections = "collections",
  Klydos = "klydos",
}

const ReviewsSection = () => {
  const [selectedTab, setSelectedTab] = useState<ReviewTab | undefined>(
    undefined,
  );
  const queryClient = useQueryClient();
  const [searchParams] = useSearchParams();
  const { data: hasNewKlydos } = useHasNewKlydosInReview();
  const { data: hasNewCollections } = useHasNewCollectionsInReview();

  const handleCollectionsClick = () => {
    setSelectedTab(ReviewTab.Collections);
    markCollectionsReviewVisited();
    queryClient.invalidateQueries({ queryKey: ["newCollectionsInReview"] });
  };

  const handleKlydosClick = () => {
    setSelectedTab(ReviewTab.Klydos);
    markKlydosReviewVisited();
    queryClient.invalidateQueries({ queryKey: ["newKlydosInReview"] });
  };

  useEffect(() => {
    const tab = searchParams.get("tab");
    if (tab === ReviewTab.Collections) {
      handleCollectionsClick();
    } else if (tab === ReviewTab.Klydos) {
      handleKlydosClick();
    }
  }, [searchParams]);

  return (
    <>
      <PageHeader
        overline="Content"
        title="Reviews"
        subtitle="Approve or reject submitted klydos and collections"
        tabs={
          <DSSegmentedTabs<ReviewTab>
            options={[
              {
                label: "Collection",
                value: ReviewTab.Collections,
                badge: !!hasNewCollections,
              },
              {
                label: "Klydos",
                value: ReviewTab.Klydos,
                badge: !!hasNewKlydos,
              },
            ]}
            value={selectedTab}
            onChange={(tab) => {
              if (tab === ReviewTab.Collections) {
                handleCollectionsClick();
              } else if (tab === ReviewTab.Klydos) {
                handleKlydosClick();
              }
            }}
          />
        }
      />
      {selectedTab === ReviewTab.Collections && <CollectionsReviews />}
      {selectedTab === ReviewTab.Klydos && <KlydosReviews />}
    </>
  );
};
export default ReviewsSection;
